import {Component, Input, OnInit} from '@angular/core';
import {ProductQuery, SearchProductEntry} from '@services/resource/search-product-resources';
import {VoteService} from '@services/vote.service';
import {merge, Observable, Subject} from 'rxjs';
import {Vote} from '@services/model/vote';
import {VoilaUserService} from '@services/voila-user.service';
import {UUID} from '@util/types';
import {map, startWith} from 'rxjs/operators';
import {MatIcon} from '@angular/material/icon';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-hp-vote-widget',
  templateUrl: './hp-vote-widget.component.html',
  styleUrls: ['./hp-vote-widget.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIcon],
})
export class HpVoteWidgetComponent implements OnInit {
  @Input() query?: ProductQuery;
  @Input() entry: SearchProductEntry;

  vote$: Observable<Vote | null>;
  updatedVote$: Subject<Vote> = new Subject<Vote>();

  constructor(
    private readonly voteService: VoteService,
    private readonly userService: VoilaUserService,
  ) {}

  ngOnInit() {
    const fetchedVote$ = this.voteService.getVotes(this.cycleId, this.entry.product.id, this.companyId).pipe(
      startWith(null),
      map((vs) => {
        if (vs && vs.length > 0) {
          return vs[0].vote;
        }
        return null;
      }),
    );

    this.vote$ = merge(fetchedVote$, this.updatedVote$);
  }

  private get cycleId(): UUID {
    return (this.query as ProductQuery).cycleFilter;
  }

  private get companyId(): UUID {
    const user = this.userService.currentUser();
    return user.companyId;
  }

  toggleVote(current: number): void {
    const productId = this.entry.product.id as UUID;
    const newVerdict = current === 1 ? 0 : 1;
    this.voteService.castVote(this.cycleId, productId, this.companyId, newVerdict).subscribe((v) => this.updatedVote$.next(v));
  }
}
